import fetch from '../utils/fetch';
import { profileURL } from 'endpoints';
const ProfileSdk = require( '@nackle/profile-sdk' );

function ProfileService( accessToken, companyId ) {
    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                authorization: `Bearer ${ accessToken }`,
                'company-id': `${ companyId }`
            },
        };
        return fetch( url, options );
    };
    
    const sdk = new ProfileSdk( profileURL, fetchWithAuth );

    const getRecovery = async ( personId ) => {
        try {
            const res = await sdk.getPlainTextRecoveryMethods( personId );

            return {
                recoveryEmail: res.recoveryEmail,
                recoveryPhone: res.recoveryPhone,
                countryCode: res.countryCode
            };
        } catch ( error ) {
            console.error( 'ERROR', error );
            throw new Error( 'Unsuccessful response from getPlainTextRecoveryMethods' );
        }
    };

    const updateRecovery = async ( personId, recoveryMethods ) => {
        try {
            return await sdk.updateRecoveryMethods( personId, recoveryMethods );
        } catch ( error ) {
            throw new Error( 'ERROR:', error );
        }

    };
    
    const searchRecovery = async ( emailAddress ) => {
        try {
            const response = await sdk.searchRecoveryMethods( { emailAddress } );
            if ( response.success ) {
                return response.results;
            }
            
        } catch ( error ) {
            throw new Error( 'ERROR from searching recovery email:', error );
        }
    };

    return {
        getRecovery,
        updateRecovery,
        searchRecovery
    };
}

export default ProfileService;